import { useSyncExternalStore } from "react";

const listeners = new Set<() => void>();

function subscribe(listener: () => void) {
  listeners.add(listener);
  window.addEventListener("popstate", listener);
  return () => {
    listeners.delete(listener);
    window.removeEventListener("popstate", listener);
  };
}

export function pushLocation(url: string) {
  window.history.pushState(null, null, url);
  listeners.forEach((listener) => listener());
}

export default function useLocationHash() {
  return useSyncExternalStore(
    subscribe,
    () => document.location.hash,
    () => ""
  );
}
